import { render, staticRenderFns } from "./NewVersionPage.vue?vue&type=template&id=5d0a6f9e&scoped=true"
import script from "./NewVersionPage.vue?vue&type=script&lang=js"
export * from "./NewVersionPage.vue?vue&type=script&lang=js"
import style0 from "./NewVersionPage.vue?vue&type=style&index=0&id=5d0a6f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0a6f9e",
  null
  
)

export default component.exports